<template>
	<div class="container-fluid">
		<service-toolbar></service-toolbar>

		<time-log-table
			:show-job="false"
			:show-user="true"
			heading="Time Logs"
			:heading-small="'Service #'+$store.service.job_num+': '+$store.service.job_name"
			:show-user-classification="true"
			:filtering-tools="true"
			:filters="[['service_id',$store.service.id]]"
			:default-filter-values="{dateFrom: defaultDateFromFilter}"
			:collapse-buttons="true"
			:editable="true"
			:service-id="$store.service && 'id' in $store.service ? $store.service.id : false">
		</time-log-table>

	</div>
</template>
<script type="text/javascript">

import ServiceToolbar from "./ServiceToolbar"
import TimeLogTable from "@/components/super_components/TimeLogTable"

import ServiceMixins from "@/mixins/ServiceMixins.js"
import TimeLogMixins from "@/mixins/TimeLogMixins.js"

export default {
	name: "ServiceTimeLogs",
	components: {
		ServiceToolbar,
		TimeLogTable
	},
	mixins: [ServiceMixins,TimeLogMixins],
	created() {
		this.setServiceIfNotSet()
	}
}
</script>
